import {Box, FormControlLabel} from "@mui/material";
import {observer} from "mobx-react";
import * as React from "react";
import PermissionAdapter from "../../../adapters/PermissionAdapter";
import PermissionCheckbox from "./PermissionCheckbox";

function PermissionListGroup({permissionGroup, form, fieldName, matchesPermissionSearch}) {
    return (
        <Box display="flex" flexDirection="column">
            {permissionGroup.permissions.map(permission => (
                <FormControlLabel
                    key={permission}
                    sx={{opacity: matchesPermissionSearch(permission) ? 1 : 0.3}}
                    control={<PermissionCheckbox permission={permission} form={form} fieldName={fieldName}/>}
                    label={new PermissionAdapter(permission).adapt()}
                />
            ))}
        </Box>
    )
}

export default observer(PermissionListGroup);
